<template>
  <thead class="bg-primary dark:bg-dark-700 sticky top-0 z-10">
    <slot></slot>
  </thead>
</template>

<script>
export default {
  name: 'TableHead'
}
</script>
